import { useEffect, useState } from 'react';

// For React components (hook approach)
export function useCrypto() {
  const [cryptoService, setCryptoService] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let mounted = true;

    if (typeof window !== 'undefined') {
      // Dynamic import with better error handling
      import('./cryptoService')
        .then((module) => {
          if (mounted) {
            setCryptoService(module.default);
            setIsReady(true);
          }
        })
        .catch((err) => {
          console.error('Failed to load crypto service:', err);
        });
    }

    return () => {
      mounted = false;
    };
  }, []);

  const encryptPassword = (password) => {
    if (!cryptoService || !password) return '';
    return cryptoService.encryptPassword(password);
  };

  return { encryptPassword, isReady };
}

// For non-React modules (non-hook approach)
let cryptoServicePromise = null;

// Initialize crypto only on client-side
if (typeof window !== 'undefined') {
  cryptoServicePromise = import('./cryptoService')
    .then((module) => module.default)
    .catch((err) => {
      console.error('Failed to load crypto service:', err);
      return null;
    });
}

// This is the function to use in non-React code
export const encryptPasswordAsync = async (password) => {
  if (typeof window === 'undefined') {
    console.warn('Attempted to encrypt password on server side');
    return '';
  }

  if (!password) {
    console.warn('Empty password provided');
    return '';
  }

  try {
    // Wait for the service to be loaded
    const service = await cryptoServicePromise;
    if (!service) {
      throw new Error('Crypto service not available');
    }
    return service.encryptPassword(password);
  } catch (err) {
    console.error('Error encrypting password:', err);
    throw err;
  }
};
